<template>
  <div class="d-flex pt-1 px-1">
    <div
      class="rounded-circle pulse"
      :style="`background-color: ${color}; height: ${size}px; width: ${size}px`"
    ></div>
    <div
      class="rounded-circle pulse-1st-delay"
      :style="`background-color: ${color}; height: ${size}px; width: ${size}px`"
    ></div>
    <div
      class="rounded-circle pulse-2nd-delay"
      :style="`background-color: ${color}; height: ${size}px; width: ${size}px`"
    ></div>
  </div>
</template>
<script setup lang="ts">
const { color = '#9E9E9E', size = 5 } = defineProps<{
  color?: string
  size?: number
}>()
</script>
<style scoped>
.pulse {
  animation: pulse-loading 1s linear infinite alternate;
  margin-right: 2px;
}

.pulse-1st-delay {
  animation: pulse-loading 1s linear 0.3s infinite alternate;
  margin-right: 2px;
}

.pulse-2nd-delay {
  animation: pulse-loading 1s linear 0.6s infinite alternate;
  margin-right: 2px;
}

@keyframes pulse-loading {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.3;
  }
}
</style>
